
import Vue from "vue";
import HeaderDropDownFilter, {
  OptionItem
} from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  status?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
  statusOptions: Array<OptionItem>;
};

export default Vue.extend({
  name: "SensorListHeader",

  components: {
    HeaderDropDownFilter
  },

  data(): DataType {
    return {
      filterCondition: {
        status: undefined
      },
      statusOptions: [
        {
          label: "登録可能",
          value: "登録可能"
        },
        {
          label: "機器識別番号登録済み",
          value: "機器識別番号登録済み",
          classes: ["red"]
        },
        {
          label: "データ不備 登録不可",
          value: "データ不備 登録不可",
          classes: ["red"]
        }
      ]
    };
  },

  methods: {
    updateFilterCondition(): void {
      this.$emit("update-filter-condition", this.filterCondition);
    }
  }
});
